export enum PhoneLineType {
  FixedVoIP = 'FixedVoIP',
  NonFixedVoIP = 'NonFixedVoIP',
  Landline = 'Landline',
  Mobile = 'Mobile',
  Other = 'Other',
}
